export type ElementRef = {
    elementDiv?: HTMLDivElement
    componentTopLeft?: HTMLDivElement
    componentTopRight?: HTMLDivElement
    componentBottomScreenWeb?: HTMLDivElement
    componentBottomScreenMobile?: HTMLDivElement
}

export type LocationType = {
    latitude: number
    longitude: number
}

export type ExtentType = {
    xmax: number
    xmin: number
    ymax: number
    ymin: number
}

export type ConfigType = {
    url: string
    username: string
    password: string
}

export type DistanceUnitType =
    | 'millimeters'
    | 'centimeters'
    | 'decimeters'
    | 'meters'
    | 'kilometers'
    | 'inches'
    | 'feet'
    | 'yards'
    | 'miles'
    | 'nautical-miles'
    | 'us-feet'

export enum MapViewClickType {
    Identify = 'identify',
    SearchStation = 'searchstation'
}

export type MapCallbackEventType = {
    onViewLoaded?: Function
    onStationLoaded?: Function
    onSystemMapLoaded?: Function
    onViewClickIdentify?: Function
    onViewClickIdentifyComplete?: Function
    onViewClickSearch?: Function
    onViewDrag?: Function,
    onSelectStationChange?: Function
}
